// import { history, useModel } from '@umijs/max';
import { Swiper, Image } from 'react-vant';
import './index.less';
import { getBannerList } from '@/service/banner';
import { useEffect, useState } from 'react';
import { history } from '@umijs/max';
import bannerUrl from '@/assets/home/banner.jpg';
interface ImageType {
  communityId: string;
  communityName?: string;
  createBy?: string;
  createTime?: string;
  image?: string;
  publishTime?: string;
  sequenceNbr?: string;
  status?: string;
  title?: string;
  updateBy?: string;
  updateTime?: string;
  urlPath?: string;
}
const Banner = (props: any) => {
  const { defaultRoom } = props
  const [images, setImages] = useState<ImageType[]>([]);

  useEffect(() => {
    setImages( []);
    const getData = () => {
      getBannerList({ pageNum: 1, pageSize: 1000, communityId: defaultRoom?.communityId, status: '1' }).then((res) => {
        console.log('广告>>', res.rows)
      
        setImages(res.rows || []);
      });
    };
    getData();
  }, [defaultRoom]);

  const toJump = (item: any) => {
    console.log(item)
    if (item.urlPath) {
      history.push(item.urlPath)
      return
    }
  }

  return (
    <div className="demo-swiper">
      {!!images.length ? 
      <><Swiper autoplay={images.length > 1}>
        {images.map((image) => (
          <Swiper.Item key={image.sequenceNbr} onClick={() => toJump(image)}>
            <Image  height="170" width="100%" src={image.image} />
          </Swiper.Item>
        ))}
      </Swiper></>:<>
      <Image src={bannerUrl} height="170" width="100%"></Image>
      </>}
    </div>
  );
};

export default Banner;
